import type {StudyDb} from '@cp/model';
import {doc, DocumentReference} from 'firebase/firestore';
import {getStudyCollection} from './getStudyCollection';

export function getStudyDocRef(moduleId: string, topic: string): DocumentReference<StudyDb> {
  return doc(getStudyCollection(moduleId), topic);
}
